import styled from 'styled-components'

import constants from 'utils/constants'

export default function ProductBanner({ bannerImg, stock }) {
  return (
    <div style={{ position: 'relative' }}>
      {stock !== undefined && stock !== null ? (
        <StockContainer>
          <StockBox>
            <StockKey>🔥 남은 수량</StockKey>
            <StockValue>{stock}</StockValue>
          </StockBox>
        </StockContainer>
      ) : null}
      <img
        src={`${constants['imagePath']}/commerce/product/banner_img/${bannerImg}`}
        alt={'product banner img'}
      />
    </div>
  )
}

const StockContainer = styled.div`
  position: absolute;
  left: 0;
  top: calc(100vw * (6 / 375));
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const StockBox = styled.div`
  width: calc(100vw * (355 / 375));
  background: rgba(0, 0, 0, 0.7);
  border-radius: calc(100vw * (7 / 375));
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: calc(100vw * (12 / 375)) 0;
`

const StockKey = styled.div`
  font-weight: 600;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #ffffff;
`

const StockValue = styled.div`
  font-weight: 800;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #ffffff;
  margin-left: calc(100vw * (7 / 375));
`
